//src/Footer.tsx
import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/favicon.svg" alt="TradeSagePro logo" className="w-6 h-6" />
              <span className="text-white text-xl font-bold">TradeSagePro</span>
            </div>
            <p className="text-[hsl(210,9%,91%)] mb-6 max-w-md">
              AI-powered market research and data analysis platform. 
              Get data-driven analysis insights including suggested data points for initiation, risk control, and target closure parameters.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link href="/about" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">About</Link>
              <Link href="/how-it-works" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">How It Works</Link>
              <Link href="/pricing" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Pricing</Link>
              <Link href="/dashboard" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Dashboard</Link>
            </div>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <div className="space-y-2">
              <Link href="/privacy" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Privacy Policy</Link>
              <Link href="/terms" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Terms of Use</Link>
              <Link href="/risk" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Risk Disclosure</Link>
              <Link href="/refund" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Refund Policy</Link>
              <Link href="/contact" className="block text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200">Contact</Link>
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}
                className="block text-left w-full text-[hsl(210,9%,91%)] hover:text-[hsl(193,100%,50%)] transition-colors duration-200"
              >
                Cookie Settings
              </button>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-[hsl(210,9%,91%)]">
            © 2026 TradeSagePro. All rights reserved.
          </p>
          <p className="mt-3 text-[hsl(210,9%,80%)] text-sm">
            Disclaimer: TradeSagePro is a data analysis and research tool. We do not provide financial, legal, or investment advice. Trading in digital assets involves substantial risk of loss and is not suitable for every investor. Past performance is not indicative of future results.
          </p>
        </div>
      </div>
    </footer>
  );
}